import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AsyncPipe, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { AdGroup } from '@app/core/models/ad-group.models';
import { ItemLabelComponent } from '@app/shared/components/campaign-adgroup-label/item-label.component';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'adspt-ad-group-label',
  templateUrl: './item-label.component.html',
  styleUrls: ['./item-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgIf, AsyncPipe, TranslateModule, SharedDirectivesModule, NgTemplateOutlet],
})
export class AdGroupLabelComponent extends ItemLabelComponent<Pick<AdGroup, 'adgroupName'>> {
  @Input()
  labelProperty = 'adgroupName' as const;

  get type(): string {
    return 'common.adgroup';
  }
}
